// Main entry: the production View.
export { ACCOUNT_TYPE_BADGE_COLOR, AccountTypeBadge, accountTypeBadgeLabel } from "./AccountTypeBadge";
export type {
    AccountBadgeType,
    AccountType,
    AccountTypeBadgeProps,
    MultisigShape,
    SquadsAccountType
} from "./AccountTypeBadge";
